import { MoreMenu } from "@/components/ui/MoreMenu";

export function ProcurementMoreMenu({ items }: { items: { label: string; onClick: () => void }[] }) {
  return <MoreMenu items={items} procurement />;
}
